export default {
  common: {
    loading: 'Chargement...',
    noData: 'Aucune donnée disponible.',
  },
  nav: {
    home: 'Accueil',
    products: 'Produit',
    about: 'À propos',
    partnership: 'Partenariat',
    blog: 'Blog',
  },
  home: {
    text: 'ACCUEIL',
    title: 'YOOXPLORE',
    hero: {
      title1: 'Renforcer les Partenaires Mondiaux',
      title2: "Sécuriser l'Avenir depuis les Airs",
      bookDemo: 'Réserver une Démo',
    },
  },
  overview: {
    title: 'Aperçu',
    subtitle: 'Plateforme UAV YOOX S3T',
    content: "Le YOOX S3T est un véhicule aérien sans pilote (UAV) avancé capable de transporter des charges lourdes, de voler de manière stable et de manœuvrer avec précision. Conçu pour être l'un des meilleurs drones autonomes du marché, il se distingue par sa longue autonomie et ses excellentes performances longue portée, idéal pour les opérations militaires, les tâches industrielles et les missions humanitaires.",
    content2: "En plus de vendre des drones, nous aidons votre marque de drones à réussir localement. Nous fournissons des solutions de production et d'assemblage localisées, vous aidant à construire votre propre système de production pour fabriquer les meilleurs drones et atteindre vos objectifs.",
  },
  scenarios: {
    title: 'Scénarios',
    subtitle: "Extensible à davantage de cas d'usage industriels",
  },
  advantages: {
    title: 'Avantages Clés',
    subtitle: "Conçu pour s'adapter à vos besoins",
  },
  products: {
    title: 'Centre de Produits',
    intro: 'Introduction aux Produits',
    subtitle: 'Plateformes de Vol Industrielles et Produits Écologiques',
    gallery: {
      all: 'Tout',
    },
    contact_business: 'Veuillez nous contacter pour plus de détails sur le produit',
  },
  about: {
    text: 'À propos',
    title: 'À propos de nous',
    teamTitle: 'Notre Équipe',
    teamSubtitle: 'Issus des meilleures entreprises mondiales',
    teamContent: "Notre équipe provient d'entreprises comme DJI, Yamaha, Apple, Tesla, etc. Nous avons en moyenne plus de dix ans d'expérience dans l'industrie des drones ainsi que dans les domaines de la sécurité et de la défense.",
    visionTitle: 'Notre Vision',
    visionSubtitle: 'Aider votre marque de drones à réussir localement',
    visionContent: "En plus de vendre des drones, nous fournissons des solutions de production et d'assemblage localisées, vous aidant à construire votre propre système de production pour fabriquer les meilleurs drones et atteindre vos objectifs.",
  },
  partnership: {
    title: 'Partenariat',
    primaryCta: 'Gros & ODM & OEM',
    secondaryCta: 'Devenir Distributeur',
    qaTitle: 'Questions Fréquentes',
  },
  blog: {
    title: 'Blog',
    heading: 'Insights et Mises à Jour',
    subheading: 'Les dernières actualités sur les drones, la localisation et les tendances du marché.',
    searchPlaceholder: 'Rechercher des articles',
  },
  contact: {
    title: 'Contactez-nous',
    title2: 'Nous serions ravis de vous entendre.',
    content1: "Si vous souhaitez plus d'informations ou coopérer avec nous, contactez-nous via WhatsApp, Telegram ou le formulaire.",
    whatsappLabel: 'WhatsApp',
    whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
    telegramLabel: 'Telegram',
    telegramValue: 'Telegram: <YOUR_TELEGRAM>',
    form: {
      title: 'Formulaire de Contact',
      subtitle: 'Nous serions ravis de vous entendre.',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      company: 'Entreprise',
      country: 'Pays/Région',
      interestLabel: 'Je suis intéressé par',
      interests: ['Achat de produits', 'Devenir distributeur', 'OEM/ODM', 'Consultation technique', 'Autre'],
      message: 'Vos besoins et description',
      submit: 'Envoyer',
      submitTip: 'Merci de nous avoir contactés. Nous vous répondrons bientôt.',
      submitError: "Échec d'envoi. Veuillez réessayer.",
    },
  },
}
